module.exports = __webpack_public_path__ + "img/学科素养训练.0def2a16.png";